import React from 'react';
import { Alert, AlertProps, Anchor, Group, Text, ThemeIcon } from '@good/ui/core';
import { useLocalStorage } from '@good/ui/hooks';
import { reactTrpc } from 'utilities/react-trpc';
import { Info } from '@good/icons';
import { Link } from 'react-router-dom';
import { useHasPermission } from 'utilities/permission-utils/permission-utils';
import { UserPermissionRole } from '@utils/enum-utils';

export const PayPeriodAlert = (props: AlertProps) => {
  const { data } = reactTrpc.serviceProvider.payPeriod.fetch.useQuery();
  const [closed, setClosed] = useLocalStorage({
    key: 'bookings-view__pay-period-alert-closed',
    defaultValue: false,
  });
  const hasPermissions = useHasPermission([UserPermissionRole.Owner, UserPermissionRole.PrimaryOwner]);
  const hasPayPeriodSet = Boolean(data?.payPeriodStartDate) && Boolean(data?.payPeriodDuration);
  const visible = !hasPayPeriodSet && !closed && hasPermissions;

  const onClose = () => {
    setClosed(true);
  };

  if (!visible) {
    return null;
  }

  return (
    <Alert
      withCloseButton
      onClose={onClose}
      color='lavender'
      w='100%'
      py='xs'
      styles={{
        body: {
          flexDirection: 'row',
          justifyContent: 'center',
        },
      }}
      {...props}
    >
      <Group gap='xs'>
        <ThemeIcon variant='transparent' color='lavender' size='xs'>
          <Info />
        </ThemeIcon>
        <Text inherit>
          Set up your pay period – Add your pay period to filter bookings and keep your team&apos;s hours in sync.
        </Text>
        <Anchor
          inherit
          component={Link}
          fw={700}
          td='underline'
          to='/account/features/finance-file-export-configuration/pay-period'
        >
          Get started
        </Anchor>
      </Group>
    </Alert>
  );
};
